var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{attrs:{"card":""}},[_vm._l((_vm.inflationChildren),function(value,index){return _c('b-tab',{key:index,attrs:{"active":value.activeToggle,"title":value.objectname},on:{"click":function($event){!value.activeToggle ? _vm.navigateTab(`${value.objectname}`) : () => {}}}})}),_c('router-view')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }